import { autoinject, LogManager } from 'aurelia-framework';
import { AuthService } from 'aurelia-authentication';

@autoinject()
export class ErrorHanderService {

	constructor(private authService: AuthService) {
		
	}

	logger = LogManager.getLogger('ErrorHanderService');

	handleApiError(apiName: string, response) {
		const responseCode = response.status;
		const message = apiName + ': failed with code: ' + responseCode ; 
		this.logger.error(message);
		this.authService.logout();
	}
}